

import axios from 'axios';
import moment from 'moment';
import { AUTH } from '../tools/ApiRoutes';

// URL Authentication Endpoint


/**
 * Iniciar sesión
 * @param {object} data { user, password }
 * @return {any} promise
 */
const login = (type, login, pass) => {

    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.post(AUTH.login, { tipo: type, login: login, contraseña: pass }, { headers })
        .then(({ data }) => {
            return data;
        });
};
/**
 * Iniciar sesión con microsoft
 * @return {any} promise
 */
const loginMS = (url) => {

    // const headers = {
    //     'Content-Type': 'application/json',
    // };

    return axios.get(`${AUTH.loginMS}?path=${encodeURIComponent(url)}`, {}, {})
        .then(({ data }) => {
            return data;
        });
};

/**
 * Intercambiar el código temporal retornado por Microsoft por tokens de sesión.
 * @param {string} loginCode - Código temporal de un solo uso
 * @return {Promise} respuesta de autenticación
 */
const exchangeLoginCode = (loginCode) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    return axios.post(AUTH.exchangeLoginCode, { loginCode }, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Cerrar sesión
 */
const logout = (type, login, refreshToken) => {

    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.post(AUTH.logout, { tipo: type, login: login, refreshToken: refreshToken }, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Renovar token de autenticación
 * @param {string} login - Usuario
 * @param {string} refreshToken - Token de refresco
 * @return {Promise} promise
 */
const refresh = (login, refreshToken) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios.post(AUTH.refresh, { login: login, refreshToken: refreshToken }, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Login con autenticación Windows/NTLM
 * @param {string} path - Ruta de redirección después del login
 * @return {Promise} promise
 */
const loginWindows = (path) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const params = path ? { path } : {};
    return axios.get(AUTH.loginWindows, { params }, { headers })
        .then(({ data }) => {
            return data;
        });
};




export const AuthService = {
    login,
    logout,
    loginMS,
    exchangeLoginCode,
    refresh,
    loginWindows,
};
